const messages = {
    /* Таблицы */
    dataIterator: {
        rowsPerPageText: "Записей на странице:",
        rowsPerPageAll: "Все",
        pageText: "{0}-{1} из {2}",
        noResultsText: "Не найдено подходящих записей",
        nextPage: "Следующая страница",
        prevPage: "Предыдущая страница"
    },
    dataTable: {
        rowsPerPageText: "Строк на странице:"
    },
    noDataText: "Отсутствуют данные",
    carousel: {
        prev: "Предыдущее изображение",
        next: "Следующее изображение"
    },

    errors: {
        accountConfirmationError: "Не удалось подтвердить учетную запись",
        cantUpdateUsersSettings: "Не удалось обновить настройки пользователя",
        emptyPatterns: "Проверьте параметры пиломатериалов, а также наличие выбранных сечений",
        errorMethod: "Не задан метод вычисления объема бревна",
        fbsDiamMaxLog: "(ФБС) Превышен максимально допустимый диаметр бревна",
        noConfirmationCodeError: "Код подтверждения не найден. Возможно учетная запись уже активирована",
        noOptimalPattern: "В результате выполнения расчетов оптимальные поставы не найдены. Проверьте параметры оборудования, пиломатериалов и бревна, затем повторите расчет",
        noSawDevices: "На линии обработки отсутствует оборудование для пиления",
        serverConnectionError: "Ошибка подключения к серверу. Попробуйте повторить операцию позже",
        volumeTableDataNotFound: "В таблице объемов отсутствуют данные для заданных значений диаметра и длины"
    },

    monthsList: {
        january:   "Январь",
        february:  "Февраль",
        march:     "Март",
        april:     "Апрель",
        may:       "Май",
        june:      "Июнь",
        july:      "Июль",
        august:    "Август",
        september: "Сентябрь",
        october:   "Октябрь",
        november:  "Ноябрь",
        december:  "Декабрь"
    },

    lineTemplates: {
        cant: "Брус",
        liveCut: "Развал",
        multiSawsFrame: "Рамный поток",
        profilingLine: "Фрезерно-профилирующая",
        chipperCanter: "Фрезерно-брусующая",
        scandinavian: "Скандинавская схема",
        torsion: "Кручением",
        bandLine: "Ленточная пила",
        bandLineWithMulti: "Ленточная пила с многопильным станком",
        bandLineWithRotate: "Ленточный станок с вращением"
    },

    volumeCalcMethods: {
        topDiamAvgRise: "Верхнего диаметра и среднего сбега",
        truncatedCone: "Усеченного конуса",
        endSections: "Концевых сечений",
        standardTables: "По таблицам ГОСТ"
    },

    gosStandards: {
        gost2708_75: "ГОСТ 2708-75",
        gost_r54365_2011: "ГОСТ Р54365-2011",
        gost2708_75Short: "ГОСТ 2708-75",
        gost_r54365_2011Short: "ГОСТ Р54365-2011"
    },

    notes: {
        trialAvailability: "Ознакомительная версия доступна сразу после регистрации",
        billExist: "Для Вас уже сформирован счёт. Создание нового счёта анулирует старый.",
        successBillSubmition: "Счёт сформирован и отправлен на указанную электронную почту. Сразу после оплаты наши сотрудники подключат Вам выбранную подписку. Приятного использования!",
        successPaymentRequest: "После оплаты подписка подключится автоматически. Вам только необходимо перезагрузить страницу приложения. Счёт на оплату и чек доступны на указанной почте. Приятного использования!",
        liveCutLine: "Данная линия является стандартной. Доступно изменение параметров многопильного станка. Добавление/удаление оборудования запрещено."
    },

    subscriptionPlans: {
        title: "Возможности и стоимость подписок на сервис MillLab",
        currency: "₽",
        monthly: "на 1 месяц",
        quarterly: "на 3 месяца",
        yearly: "на год",
        threeYear: "3 года",
        free: "Ознакомительная",
        standard: "Стандартная",
        standardPlus: "Стандартная Плюс",
        professional: "Профессиональная",
        standardInfo: "для индивидуального использования",
        standardPlusInfo: "для малых и средних предприятий",
        professionalInfo: "для средних и крупных предприятий",
        availableFeatures: "Доступные функции",
        restrictions: "Ограничения",
        usersAmount: "Количество пользователей",
        patternsAmount: "Количество доступных для хранения результатов в библиотеке поставов",
        modelsAmount: "Количество доступных для хранения моделей брёвен",
        sawProfilesAmount: "Количество профилей оборудования",
        features: [
            "Редактирование справочников пиломатериалов, длин, стоимости сырья и продукции",
            "Оптимизация по объемному выходу с учетом номинальных и пильных размеров",
            "Оптимизация по цене с учетом зависимости стоимости от сечения, длины пиломатериала, а также стоимости щепы и опилка",
            "Возможность создания индивидуальной лесопильной линии",
            "Оптимизация с учетом кромкообрезки (роспуск необрезной доски на несколько обрезных), возможность распила центрального постава",
            "Печатная форма отчета оптимизаций и сохранение результата в библиотеку",
            "Просмотр трехмерных моделей поставов и бревен",
            "Ручное создание и редактирование поставов",
            "Подбор оптимального диаметра под постав и диапазона диаметров для эффективного пиления",
            "Сохранение результатов оптимизации согласно заказам, экспорт и импорт",
            "Оптимизация с учетом кривизны бревна",
            "Оптимизация с учетом эллипсности бревна",
            "Расчёт с учётом допустимого обзола и бессердцевинной доски",
            "Интеграция с другими продуктами компаний \"ВекторПромСофт\" и \"Автоматика-вектор\""
        ],
    },

    paymentTypes: {
        bankcard: "Банковская карта",
        sbp: "Система быстрых платежей",
        bill: "Оплата по счёту",
        bankcardAndSbp: "Банковская карта и СБП",
    },

    /* Модули */
    calc: "Оптимизация",
    general: "Система",
    lines: "Линии",

    appName: "MillLab",
    avtomatikaVektor: "Автоматика-Вектор",
    vektorPromSoft: "ВекторПромСофт",

    acceptCookies:"Принять и закрыть",
    acceptLicense: "Принимаю лицензионное соглашение",
    acceptPolicy: "Принимаю политику конфиденциальности",
    accessControl: "Контроль доступа",
    accessDenied: "Доступ запрещен",
    accountConfirmed: "Учетная запись подтверждена",
    aclCreate: "Создание",
    aclDelete: "Удаление",
    aclExport: "Экспорт",
    aclModify: "Изменение",
    aclRead: "Чтение",
    aclUpdated: "Список контроля доступа обновлен",
    action: "Действие",
    actualSizes: "пильные",
    addLineTemplate: "Создать линию по шаблону",
    address: "Адрес",
    administration: "Администрирование",
    administrator: "Администратор",
    all: "Все",
    alongCurvature: "Вдоль кривизны",
    alongLogAxis: "Обработка вдоль центральной оси бревна",
    amount: "Количество",
    amountIn: "Количество в",
    amountShort: "Кол-во",
    and: "и",
    applicationError: "Ошибка приложения",
    apply: "Применить",
    archived: "Архив",
    aspen: "Осина",
    asymmetric: "Асимметричный",
    attention: "Внимание!",
    atTheButt: "У комля",
    atTheTop: "У вершины",
    authorization: "Авторизация",
    auto: "Авто",
    automaticallyCalculateTaper: "Вычислять сбег автоматически",
    averageTaper: "Средний сбег",
    avgCurv: "Сред. крив.",
    avgCurvature: "Сред. кривизна",
    batchOfLogs: "Партию бревен",
    bandSaw: "Ленточная пила",
    bandSawShort: "Лент. пила",
    bark: "Кора",
    birch: "Береза",
    boards: "Доски",
    boardsCuttingPossibility: "Возможность роспуска досок",
    boardsParameters: "Параметры досок",
    boardsVolume: "Объем досок",
    boardsV: "V дос.",
    boardType: "Тип доски",
    bottom: "Комель",
    byCantWidth: "По ширине бруса",
    byPrice: "По цене",
    byVolume: "По объему",
    buySubscription: "Купить подписку",
    calculate: "Рассчитать",
    calculated: "Рассчитано",
    calculatedBoards: "Рассчитанные доски",
    calculationError: "Не удалось произвести вычисления",
    calculation: "Расчет",
    calculations: "Расчеты",
    calculationDelete: "Удаление расчета",
    calculators: "Калькуляторы",
    calculateAmount: "Количество пиломатериалов в указанных кубаметрах",
    calculateVolume: "Объем пиломатериалов из указанного количества",
    cancel: "Отмена",
    cantCreateCompany: "Не удалось создать компанию",
    cantCreateContract: "Не удалось создать заказ",
    cantCreateDimension: "Не удалось создать сечение",
    cantCreateLength: "Не удалось создать длину",
    cantCreateUser: "Не удалось создать учетную запись пользователя",
    cantDeleteCompany: "Не удалось удалить компанию",
    cantDeleteContract: "Не удалось удалить заказ",
    cantDeleteDimension: "Не удалось удалить сечение",
    cantDeleteLength: "Не удалось удалить длину",
    cantDeleteLumber: "Не удалось удалить пиломатериал",
    cantDeleteLumberGroup: "Не удалось удалить группу пиломатериалов",
    cantDeleteModel: "Не удалось удалить модель",
    cantDeletePattern: "Не удалось удалить постав",
    cantDeletePrice: "Не удалось удалить цену",
    cantDeleteProfile: "Не удалось удалить профиль",
    cantDeleteUser: "Не удалось удалить пользователя",
    cantLoad3DModelData: "Не удалось загрузить данные 3D модели",
    cantLoad3DModelsData: "Не удалось загрузить данные 3D моделей",
    cantLoadACL: "Не удалось получить список контроля доступа",
    cantLoadCalcMethodsData: "Не удалось получить список методов расчета",
    cantLoadCompaniesData: "Не удалось получить данные компаний",
    cantLoadContractsData: "Не удалось получить данные о заказах",
    cantLoadConfig: "Не удалось получить конфигурацию",
    cantLoadData: "Не удалось получить данные",
    cantLoadDimensionsData: "Не удалось получить данные о сечениях",
    cantLoadEquipmentData: "Не удалось получить данные об оборудовании",
    cantLoadEquipmentProfiles: "Не удалось получить профили оборудования",
    cantLoadEventsData: "Не удалось получить данные о событиях",
    cantLoadGroupsData: "Не удалось получить данные о группах",
    cantLoadLengthsData: "Не удалось получить данные о длинах",
    cantLoadLoginInfo: "Не удалось получить данные об авторизации",
    cantLoadLumberData: "Не удалось получить данные о пиломатериалах",
    cantLoadModulesData: "Не удалось получить данные о модулях",
    cantLoadPatternsData: "Не удалось получить данные о поставах",
    cantLoadPricesData: "Не удалось получить данные о ценах",
    cantLoadProfiles: "Не удалось получить профили",
    cantLoadSettings: "Не удалось получить настройки",
    cantLoadSpeciesData: "Не удалось получить данные о породах",
    cantLoadSubscriptionInfo: "Не удалось получить данные о подписке",
    cantLoadSystemLog: "Не удалось получить системный журнал",
    cantLoadTasksData: "Не удалось получить данные задач",
    cantLoadUserInfo: "Не удалось получить данные пользователя",
    cantLoadUsersData: "Не удалось получить данные пользователей",
    cantProduction: "Производство бруса",
    cantSaveData: "Не удалось сохранить данные",
    cantSaveLumberGroup: "Не удалось сохранить группу пиломатериалов",
    cantSavePattern: "Не удалось сохранить постав",
    cantSaveProfile: "Не удалось сохранить профиль",
    cantScanner: "Сканер бруса",
    cantSendMessage: "Не удалось отправить сообщение",
    cant: "Брус",
    cantType: "Тип бруса",
    cantOffset: "Сдвиг от центральной оси",
    cantUpdateACL: "Не удалось обновить список контроля доступа",
    cantUpdateCalculation: "Не удалось обновить расчёт",
    cantUpdateCompany: "Не удалось обновить данные компании",
    cantUpdateContract: "Не удалось обновить заказ",
    cantUpdateData: "Не удалось обновить данные",
    cantUpdateLength: "Не удалось обновить длину",
    cantUpdatePrices: "Не удалось обновить цены",
    cantUpdateSubscription: "Не удалось обновить параметры подписки",
    cantUpdateUser: "Не удалось обновить данные пользователя",
    cantUploadFile: "Не удалось загрузить файл",
    cantUploadModel: "Не удалось загрузить 3D модель",
    cantUploadPattern: "Не удалось загрузить постав",
    captchaAPICallFailed: "Во время проверки CAPTCHA возникла ошибка, повторите попытку позже",
    captchaCheckNegative: "Вы не прошли проверку CAPTCHA. Ваши действия очень похожи на автоматизированные",
    catalogs: "Справочники",
    cedar: "Кедр",
    centralBoard: "Центральная доска",
    centralBoards: "Центральные доски",
    centralAndSideBoard: "Центральная и боковая доска",
    centralBoardsCutting: "Роспуск центральных досок",
    centralBoardsMinTotalThickness: "Мин. сумм. толщина центр. досок",
    centralHalfTimberSawing: "Распил центрального лафета",
    centralKerf: "Центральный пропил",
    circularSaw: "Круглопильный станок",
    circularSawShort: "Круглопил.",
    clear: "Очистить",
    clearFormRequest: "Вы дествительно хотите очистить форму?",
    clearTheForm: "Очистка формы",
    cleanKerf: "Подчистной пропил",
    cleanSawsUsed: "Используется подчистка",
    close: "Закрыть",
    clickToNavigate: "Нажмите для перехода",
    cm: "см",
    cookiesPolicy: "Политика cookies-файлов",
    cookiesMessageFirstRow: "Этот веб-сайт использует cookie-файлы!",
    cookiesMessageSecondRow: "Продолжая его использовать, вы соглашаетесь с использованием cookie-файлов.",
    companies: "Компании",
    company: "Компания",
    comment: "Комментарий",
    contract: "Заказ",
    contracts: "Заказы",
    contractNumber: "Номер заказа",
    companyAlreadyRegistered: "Компания с таким названием уже зарегистрирована. Для создания учетной записи обратитесь к ее администратору",
    companyCreated: "Новая компания создана",
    companyDelete: "Удаление компании",
    contractDeelte: "Удаление заказа",
    companyName: "Название компании",
    companyUpdated: "Данные компании обновлены",
    confirm3DModelDelete: "Вы действительно хотите удалить 3D модель?",
    confirmationCodeNotFound: "Код подтверждения не найден",
    confirmCalculationDelete: "Вы действительно хотите удалить расчет?",
    confirmCompanyDelete: "Вы действительно хотите удалить компанию?",
    confirmContractDelete: "Вы действительно хотите удалить заказ?",
    confirmDimensionDelete: "Вы действительно хотите удалить сечение?",
    confirmLengthDelete: "Вы действительно хотите удалить длину?",
    confirmLengthGroupDelete: "Вы действительно хотите удалить группу длин?",
    confirmLumberDelete: "Вы действительно хотите удалить пиломатериал?",
    confirmLumberGroupDelete: "Вы действительно хотите удалить группу пиломатериалов?",
    confirmPatternDelete: "Вы действительно хотите удалить постав?",
    confirmPriceDelete: "Вы действительно хотите удалить цену?",
    confirmProfileDelete: "Вы действительно хотите удалить текущий профиль?",
    confirmUnsaved: "Есть несохраненные изменения! Вы действительно хотите перейти в другой раздел? Это приведет к потере несохраненных данных!",
    confirmUserDelete: "Вы действительно хотите удалить учетную запись пользователя?",
    conoidMethod: "Усеченного конуса",
    contact: "Контакт",
    contacts: "Контакты",
    copiedToClipboard: "Скопировано в буфер обмена",
    copyToClipboard: "Копировать в буфер обмена",
    corelessBoard: "Бессердцевинная доска",
    create: "Создать",
    createModifyDate: "Дата создания/изменения",
    createPatternsLimitReachedMessage: "Ваш тарифный план не позволяет создать больше поставов. Удалите старые или перейдите на тарифный план с большими возможностями",
    createUsersLimitReachedMessage: "Ваш тарифный план не позволяет создать больше пользователей. Удалите существующих или перейдите на тарифный план с большими возможностями",
    currentEdition: "Текущая редакция",
    currentPattern: "Текущий постав",
    curvature: "Кривизна",
    curvatureCenter: "Центр кривизны",
    curvatureSettings: "Параметры кривизны",
    cuttingOptimization: "Оптимизация пиления",
    cutWidthAlongTheEdge: "Ширина пропила по кромке",
    cutWidthAlongThePlate: "Ширина пропила по пласти",
    customer: "Покупатель",
    cylinderCant: "Оцилиндрованный",
    darkTheme: "Темная схема",
    dataSaved: "Данные сохранены",
    dataSaveError: "Не удалось сохранить данные",
    dataUpdated: "Данные обновлены",
    date: "Дата",
    dButt: "Диаметр комля",
    delete: "Удалить",
    deleteProfile: "Удаление профиля",
    denyEdit: "Запретить редактирование",
    denyExport: "Запретить экспорт",
    denyImport: "Запретить импорт",
    descriptionStepsToReproduce: "Описание проблемы (шаги для воспроизведения)",
    diameter: "Диаметр",
    diameterCant: "Диаметр бруса",
    diameterBottom: "Диаметр комля",
    diameterShort: "D.",
    //diametersU: "Диаметры учетные",
    diameterTop: "Диаметр вершины",
    diameterU: "Диаметр учетный",
    dimension: "Сечение",
    dimensionCreated: "Сечение создано",
    dimensionDelete: "Удаление сечения",
    dimensionUpdated: "Сечение обновлено",
    dimensions: "Сечения",
    distribution: "Распределение",
    displayPrices: "Отображать цены",
    displayLogBottom: "Отображать комель",
    displayPatternSizes: "Отображать размеры постава",
    disableCalculationMessage: "Для выполнения расчетов необходимо выбрать сечения и профиль оборудования. Настройка лесопильной линии выполняется в разделе Справочники - Профили оборудования.",
    download: "Скачать",
    drying: "Усушка",
    dTop: "Диаметр вершины",
    dTopShort: "D верш.",
    edit: "Редактировать",
    edited: "Отредактировано",
    editionFrom: "Редакция от",
    edgeTrimmer: "Кромкообрезной станок",
    edgeTrimmerShort: "Кромкообр. станок",
    edgeTrimmerUsed: "Используется кромкообрезной",
    ellipseRatio: "Эллипсность",
    eMail: "Эл. почта",
    eMailHint: "Для информировании о статусе оплаты",
    eMailAddress: "Адрес электронной почты",
    eMailAddressRejected: "Сервер не принял указанный вами адрес, проверьте, возможно вы опечатались",
    eMailIsDisposable: "Вы не можете использовать для регистрации адрес временной электронной почты",
    emptyLineErrorMessage: "Не могу сохранить пустую линию",
    endSectionMethod: "Концевых сечений",
    equipment: "Оборудование",
    equipmentProfile: "Профиль оборудования",
    equipmentProfiles: "Профили оборудования",
    error: "Ошибка",
    errorDuringRequest: "Во время выполнения запроса произошла ошибка",
    even: "Четный",
    executionTime: "Время выполнения",
    exit: "Выход",
    expenses: "Затраты",
    expensesM3: "Затраты на м3",
    export: "Экспортировать",
    expenditure: "Расход",
    exportToExternalApp: "Экспортировать во внешнее приложение",
    falseCore: "Ложное ядро",
    falseCorePricePrcnt: "Стоимость п/м с ложным ядром, %",
    fbs: "Фрезерно-брусующий станок",
    fbsShort: "ФБС",
    fileName: "Имя файла",
    fileNotSelected: "Файл не выбран",
    fileParsingError: "Ошибка парсинга файла",
    fileTooLarge: "Файл слишком большой",
    finalValue: "Конечное значение",
    findingTheOptimalDiameter: "Поиск оптимального диаметра",
    fir: "Пихта",
    first3: "Первые 3",
    first5: "Первые 5",
    first10: "Первые 10",
    firstName: "Имя",
    firstRun: "Первый запуск",
    forgotPassword: "Я забыл пароль",
    fromTopToButt: "От вершины к комлю",
    fromLogVolume: "От объема бревна",
    fromLumberVolume: "От объема пиломатериалов",
    freeSubscriptionInfo: "Ознакомительная подписка имеет ряд ограничений.<br>Расчёты доступны только со стандартными пиломатериалами.<br>Нажмите на кнопку для перехода на страницу с информацией о доступных подписках.",
    fullRange: "Полный диапазон",
    fullscreenMode: "Полноэкранный режим",
    goToPayment: "Перейти к оплате",
    groupName: "Название группы",
    groupNameCantBeEmpty: "Название группы не может быть пустым",
    halfCant: "Полубрус",
    hasCalculations: "Есть расчеты",
    hasMyCalculations: "Есть мои расчеты",
    help: "Справка",
    history: "История",
    home: "Домашняя страница",
    horizontalSaw: "Горизонтальная пила",
    horizontalSawShort: "Гориз. пила",
    humidity: "Влажность",
    imageExportCompleted: "Экспорт изображения завершен",
    import: "Импорт",
    incorrectEMailOrPassword: "Некорректно указан адрес электронной почты или пароль",
    incorrectValue: "Некорректное значение",
    information: "Информация",
    initialValue: "Начальное значение",
    interface: "Интерфейс",
    invalidEMail: "Некорректный адрес электронной почты",
    kerf: "Пропил",
    kerfExt: "Пропил внеш.",
    kg: "кг",
    labeling: "Маркировка",
    language: "Язык",
    larch: "Лиственница",
    lastName: "Фамилия",
    lastNews: "Последние новости",
    length: "Длина",
    lengthGroup: "Группа длин",
    lengthGroupDelete: "Удаление группы длин",
    lengthGroupDeleted: "Группа длин удалена",
    lengthGroupModified: "Группа длин изменена",
    lengthGroups: "Группы длин",
    lengthGroupSaved: "Группа длин сохранена",
    lengthCreated: "Длина создана",
    lengthDelete: "Удаление длины",
    lengthM: "Длина, м",
    lengths: "Длины",
    lengthsAndVolumes: "Длины и объемы",
    lengthUpdated: "Длина обновлена",
    libraries: "Библиотеки",
    licenseAgreement: "Лицензионное соглашение",
    lime: "Липа",
    limits: "Ограничения",
    line: "Линия",
    lineChanged: "Изменена",
    lineChangedHint: "Есть несохраненные изменения",
    load: "Загрузить",
    loadTesting: "Нагрузочное тестирование",
    lock: "Заблокировать",
    lockCoreless: "Заблокировать настройки бессердцевинной доски",
    lockCurvature: "Заблокировать настройки кривизны",
    lockWane: "Заблокировать настройки обзола",
    log: "Бревно",
    logsAmount: "Количество бревен",
    logDimensions: "Параметры бревна",
    logLength: "Длина бревна",
    logParameters: "Параметры бревна",
    logsParameters: "Параметры бревен",
    logsScanner: "Сканер бревен",
    logVolume: "Объем бревна",
    logV: "V бр.",
    lumber: "Пиломатериалы",
    lumberDelete: "Удаление пиломатериала",
    lumberGroup: "Группа пиломатериалов",
    lumberGroupDelete: "Удаление группы пиломатериалов",
    lumberGroupDeleted: "Группа пиломатериалов удалена",
    lumberGroupModified: "Группа пиломатериалов изменена",
    lumberGroups: "Группы пиломатериалов",
    lumberGroupSaved: "Группа пиломатериалов сохранена",
    lumberImport: "Импорт пиломатериалов",
    lumberCalculator: "Калькулятор пиломатериалов",
    lumbersAmount: "Количество пиломатериалов",
    lumbersVolume: "Объем пиломатерила (количество кубов)",
    lumberShrinkage: "Усушка",
    lumberShrinkageCalculation: "Метод вычисления усушки пиломатериала",
    lumberWaneCalculation: "Метод вычисления объема пиломатериала с обзолом",
    m: "м",
    m3: "м3",
    maxAmount: "Макс. кол-во",
    maxCantThickness: "Макс. толщина бруса",
    maxCurv: "Макс. крив.",
    maxCurvature: "Макс. кривизна",
    maxCuttingDepth: "Макс. глубина фрезерования",
    maximalCurvature: "Максимальная кривизна",
    maxLines: "Макс. кол-во профилей оборудования",
    maxModels: "Макс. кол-во 3D моделей",
    maxPatterns: "Макс. кол-во поставов",
    maxProfilingDepth: "Макс. глубина профилирования",
    maxSawsAmount: "Макс. кол-во пил",
    maxSideBoardsAmount: "Макс. кол-во боковых досок с каждой стороны",
    maxUsers: "Макс. кол-во пользователей",
    maxWaneLength: "Макс. длина обзола",
    message: "Сообщение",
    messageSent: "Сообщение отправлено",
    messageType: "Тип сообщения",
    messageEmptyLengthRange: "Данное поле можно оставить пустым, тогда длины будут задаваться диапазоном на основе размеров бревна",
    //messageTypes: "Типы сообщений",
    middleName: "Отчество",
    minCurv: "Мин. крив.",
    minCurvature: "Мин. кривизна",
    minDmm: "Мин. диаметр, мм",
    minimalCurvature: "Минимальная кривизна",
    minimalLength: "Минимальная длина",
    minTopSideBoardsWidth: "Мин. ширина крайних досок в вершине",
    mm: "мм",
    modelDeleteError: "Ошибка. Не удалось удалить модель",
    modelDeleted: "Модель удалена",
    modified: "Изменено",
    module: "Модуль",
    modules: "Модули",
    ms: "мс",
    multiSaw: "Многопильный станок",
    multiSawShort: "Многопил.",
    my: "Мои",
    myAccount: "Моя учетная запись",
    mySubscription: "Моя подписка",
    name: "Имя",
    new: "Новый",
    newGroup: "Новая группа",
    newProfile: "Новый профиль",
    no: "Нет",
    noCurv: "Нет крив.",
    noCurvature: "Нет кривизны",
    noGroup: "Нет группы",
    nominalSize: "Номинальный размер",
    nominalSizes: "номинальные",
    noSpeciesSelectedWarning: "Не выбраны породы! Для устранения проблемы перейдите в справочник пород",
    notLoggedIn: "Не авторизован",
    notUsed: "Не используется",
    odd: "Нечетный",
    open: "Открыть",
    operator: "Оператор",
    optimalDiameter: "Оптимальный диаметр",
    optimalDiametersRange: "Диапазон оптимальных диаметров",
    optimization: "Оптимизация",
    optimizations: "Оптимизации",
    optimizationByWidth: "Оптимизация раскроя по ширине",
    optimizationMethod: "Метод оптимизации",
    optimizerResponseIsNull: "Оптимизатор не вернул результат",
    output: "Выход",
    outputDeltaForCalculatingOptimalDiamRange: "Дельта выхода для расчета диапазона оптимальных диаметров",
    ok: "ok",
    oneItemVolume: "Объем одной единицы",
    oneItemWeight: "Вес одной единицы",
    oneItemPrice: "Стоимость одной единицы",
    oneItemExpenses: "Затраты на одну единицы",
    oneM3Weight: "Масса одного м3 пиломатериалов",
    password: "Пароль",
    passwordCantBeEmpty: "Пароль не может быть пустым",
    passwordChanged: "Пароль успешно изменен",
    passwordChangeError: "Во время смены пароля произошла ошибка",
    passwordConfirm: "Подтверждение пароля",
    passwordReset: "Сброс пароля",
    passwordResetMessageSent: "Письмо со ссылкой для сброса пароля отправлено на указанный адрес электронной почты",
    passwordResetReminder: "Для сброса пароля введите указанный при регистрации адрес электронной почты. Если вы забыли адрес, обратитесь к вашему системному администратору или в службу поддержки",
    passwordsMismatch: "Введенные пароли не совпадают",
    pattern: "Постав",
    patternDeleteError: "Не удалось удалить постав",
    patternDeleted: "Постав удален",
    patternExportCompleted: "Экспорт постава завершен",
    patternExportError: "Во время экспорта постава произошла ошибка, возможно принимающее ПО в данный момент недоступно, повторите попытку позже",
    patternName:"Название постава",
    patterns: "Поставы",
    patternSample: "Образец постава",
    patternsLibrary: "Библиотека поставов",
    patternSolidBackground: "Сплошной фон у постава",
    patternType: "Тип постава",
    pattern3dView: "Трехмерная модель постава",
    patternFile: "Файл постава",
    paymentType: "Способ оплаты",
    pc: "шт",
    pieces: "штук",
    period: "Период",
    //personalCabinet: "Личный кабинет",
    personalDataAgreement: "Даю согласие на обработку моих персональных данных",
    phone: "Телефон",
    pine: "Сосна",
    price: "Цена",
    priceDelete: "Удаление цены",
    prices: "Цены",
    priceM3: "Цена за м3",
    print: "Печатать",
    printBatchOfLogs: "Отчёт для партии бревен",
    privacyPolicy: "Политика конфиденциальности",
    profile: "Профиль",
    profileDeleted: "Профиль удален",
    profileName: "Название профиля",
    profileNameCantBeEmpty: "Название профиля не может быть пустым",
    profileSaved: "Профиль сохранен",
    profilingMachine: "Устройство профилирования",
    profilingMachineShort: "Устр. профилир.",
    programMaxExecutionTimeExceeded: "Превышено максимальное время выполнения программы",
    qty: "Кол-во",
    rangeOfValues: "Диапазон значений",
    rawMaterials: "Сырье",
    readOnly: "Только чтение",
    rectangle: "Прямоугольник",
    reCaptchaNoteP1: "Этот сайт защищен reCAPTCHA.",
    reCaptchaNoteP2: " Google",
    rectangleCant: "Прямоугольный",
    registration: "Регистрация",
    registrationFailed: "Регистрация не удалась, обратитесь в службу технической поддержки",
    registrationSuccessful: "Вы успешно зарегистрировались. теперь вы можете авторизоваться в системе. Также не забудьте подтвердить адрес электронной почты. Для этого перейдите по указанной в высланном вам письме ссылке.",
    registrationAsNaturalPerson: "Регистрация физического лица",
    reload: "Перезагрузить",
    reloginAfterEMailChange: "Вы должны повторно авторизоваться после смены адреса электронной почты",
    rename: "Переименовать",
    requestBill: "Запросить счет",
    requiredField: "Обязательное поле",
    requiredFieldIsEmpty: "Не заполнено обязательное поле",
    requiredFieldPointer: "* указывает на обязательное поле",
    requireValidEmail: "Укажите корректный адрес электронной почты",
    reset: "Сбросить",
    report: "Отчет",
    reports: "Отчеты",
    rememberMe: "Запомнить меня",
    role: "Роль",
    rotate: "Повернуть",
    rotateAndPositioningDev: "Устройство вращения и позициониорвания",
    rotateAndPositioningDevShort: "Устр. вращ. и позиц.",
    rotateLog90deg: "Повернуть бревно на 90 градусов",
    rotatePattern: "Повернуть постав",
    rotateToStartPosition: "Вернуть в исходное положение",
    rotationAngle: "Угол поворота",
    sameWidthSides: "Боковые одной толщины",
    sameSizeSides: "Боковые доски одного размера",
    save: "Сохранить",
    savedСalculations: "Сохраненные расчеты",
    saveAs: "Сохранить как",
    saveGroup: "Сохранить группу",
    saveInfo: "Сохранить информацию",
    savingPatternsAmount: "Количество сохраняемых поставов",
    savePattern: "Сохранить постав",
    saveProfile: "Сохранить профиль",
    saveProfilesLimitReachedMessage: "Ваш тарифный план не позволяет сохранить больше профилей оборудования. Удалите старые или перейдите на тарифный план с большими возможностями",
    saw: "пила",
    sawAxis: "Ось пиления",
    sawdust: "Опилки",
    sawdustPriceM3: "Стоимость 1 м3 опилок",
    sawingSettings: "Параметры пиления",
    saws: "пилы",
    sawSize: "Пильный размер",
    sawsThicknessByKerfHeight: "Толщина пил зависит от высоты пропила",
    sawWaste: "Отходы пиления",
    sawWidthDependOnKerf: "Толщина пил зависит от высоты пропила",
    scaleDownByLength: "Сжать по длине",
    scanner: "Сканер",
    screenshot: "Снимок экрана",
    search: "Поиск",
    searchTopics: "Поиск раздела",
    searchLumber: "Поиск сечения",
    select: "Выбрать",
    selectAll: "Выбрать все",
    selectCuts: "Выбрать сечения",
    selectFile: "Выбрать файл",
    selectImage: "Выбрать изображение",
    send: "Отправить",
    sendMailError: "Не удалось отправить письмо для подтверждения адреса электронной почты",
    sessionExpired: "Время действия сессии истекло, требуется повторная авторизация",
    sessionIdMismatch: "Несовпадение идентификатора сессии. Вероятно, ваши учетные данные были использованы для входа на другом компьютере. Текущая сессия завершена",
    settings: "Параметры",
    settingsSaved: "Параметры сохранены",
    showArchived: "Показать архивные",
    showCalculations: "Показать расчеты",
    showCutScheme: "Показать схему распиловки",
    showMessage: "Показать сообщение",
    showSizes: "Показывать размеры",
    showAxes: "Центральные оси",
    sideBoard: "Боковая доска",
    sideBoards: "Боковые доски",
    sideBoardsSawing: "Распил боковых досок",
    singleValue: "Одно значение",
    site: "Сайт",
    sorting: "Сортировка",
    species: "Породы",
    speciesAlt: "Порода",
    speciesSwitch: "Переключение породы",
    speciesSwitchRequest: "Переключение породы приведет к сбросу текущего постава, Вы действительно хотите продолжить?",
    spruce: "Ель",
    standards: "Стандарты",
    start: "Старт",
    started: "Запущен",
    status: "Статус",
    step: "Шаг",
    stop: "Стоп",
    stopped: "Остановлен",
    subject: "Тема",
    submitApplication: "Подать заявку",
    subscription: "Подписка",
    subscriptionAlmostExpired: "Срок действия подписки почти истек. Осталось дней:",
    subscriptions: "Подписки",
    subscriptionExpired: "Срок действия подписки истек",
    subscriptionExpiredDate: "Дата окончания подписки",
    subscriptionLevel: "Уровень подписки",
    /*
    subscriptionLevel1: "Ознакомительная",
    subscriptionLevel2: "Эконом",
    subscriptionLevel3: "Для средних предприятий",
    subscriptionLevel4: "Многопользовательская",
    subscriptionLevel5: "Профессиональная",
    subscriptionLevel6: "Холдинг",
    */
    subscriptionRenewal: "Продление подписки",
    subscriptionUpdated: "Параметры подписки обновлены",
    support: "Техническая поддержка",
    supportHint: "Вы можете отправить вопрос в службу технической поддержки, ответ будет отправлен на указанный при регистрации адрес электронной почты",
    symmetric: "Симметричный",
    symmetricSideBoards: "Симметричное добавление боковых досок",
    sysLog: "Системный журнал",
    screenPattern: "Скриншот постава",
    screenPatternWitnInfo: "Скриншот постава с параметрами",
    screenPatternWithFullInfo: "Скриншот расчета",
    tariffs: "Тарифы",
    tableData: "Табличные данные",
    tablesMethod: "По таблицам ГОСТ",
    taper: "Сбег",
    tasks: "Задания",
    tasksHistory: "История заданий",
    termsOfService: "Условия обслуживания",
    test: "Тест",
    testReport: "Отчет о тестировании",
    temporaryLengthChange: "Временное изменение длины сечения",
    thickness: "Толщина",
    threeDLibrary: "Библиотека 3D моделей",
    threeDModels: "3D модели",
    time: "Время",
    title: "Заголовок",
    toggleCuts: "Переключить отображение обрезков",
    toggleLog: "Переключить отображение бревна",
    toggleCurvatureMode: "Переключить режим отображения кривизны",
    topDMethod: "Верхнего диаметра и среднего сбега",
    total: "Итого",
    totalExecutionTime: "Итоговое время выполнения",
    totalWeight: "Общий вес",
    totalPrice: "Общая стоимость",
    totalExpenses: "Общие затраты",
    top: "Вершина",
    tutorials: "Примеры использования",
    twoRowsAfterFrame: "После рамы 2 ряда",
    type: "Тип",
    trapeze: "Трапеция",
    tryForFree: "Попробовать бесплатно",
    unsupportedPattern: "Неподдерживаемый постав",
    unsupportedPatternInfo: "В текущей версии приложения поддерживается поиск оптимального диаметра только у простых поставов, которые не содержат распиленных боковых или центральных досок",
    unsupportedPatternInfoInEditDialog: "В текущей версии приложения поддерживается редактирование только у простых поставов, которые не содержат распиленных боковых или центральных досок",
    uploadModelsLimitReachedMessage: "Ваш тарифный план не позволяет загрузить больше моделей. Удалите старые или перейдите на тарифный план с большими возможностями",
    uploadPatternsLimitReachedMessage: "Ваш тарифный план не позволяет загрузить больше поставов. Удалите старые или перейдите на тарифный план с большими возможностями",
    user: "Пользователь",
    userAlreadyExists: "Пользователь с таким адресом электронной почты уже зарегистрирован, если вы забыли пароль, пройдите процедуру его сброса или обратитесь к своему системному администратору для его замены",
    userCreated: "Учетная запись пользователя создана",
    userDelete: "Удаление учетной записи",
    userInterface: "Интерфейс пользователя",
    userRegistered: "Учетная запись создана, вам отправлено письмо со ссылкой для ее активации",
    users: "Пользователи",
    userUpdated: "Данные пользователя обновлены",
    userVolumeInput: "Самостоятельный ввод объема пиловочника пользователем",
    usingCentralAsSide: "Использовать выбранные центральные сечения также в качестве боковых",
    usingWane: "Расчет с учетом допустимого обзола",
    validThrough: "Действует до",
    valueAlreadyExists: "Значение уже существует",
    valueCantBeEmpty: "Значение не может быть пустым",
    volume: "Объем",
    volumeCalculationMethod: "Метод расчета объемов",
    volumeCalculationMethods: "Методы расчета объемов",
    volumeCalculationStandard: "Таблица стандартов",
    volumeCalculationStandards: "Таблицы стандартов",
    wane: "Обзол",
    wanelessCentralBoards: "Безобзольные центральные доски",
    waneWidth: "Ширина обзола",
    warning: "Предупреждение",
    width: "Ширина",
    woodChips: "Щепа",
    woodChipsCoef: "Коэффициент щепы",
    woodChipsPriceM3: "Стоимость 1 м3 щепы",
    yes: "Да",

    youSearchFor: "По вашему запросу \"",
    foundNoResults: "\" ничего не найдено"
}

export default messages;
